import type { WorkSession } from '@/types/workSession.type';
import { Badge } from '../ui/badge';

type WorkSessionsStatusBadgeProps = {
   session: WorkSession;
   size?: "sm" | "xs";
}
export const WorkSessionStatusBadge = ({session, size = "sm"}: WorkSessionsStatusBadgeProps) => {
    const isDone = !!session.endTime; // si la session a un endTime, elle est terminée

    const base =
    size === "xs"
      ? "text-xs"
      : "";

    return (
       <Badge
      variant={isDone ? "default" : "secondary"}
      className={[
        "border-0",
        base,
        isDone
          ? "bg-success/10 text-success hover:bg-success/20"
          : "bg-warning/10 text-warning hover:bg-warning/20",
      ].join(" ")}
    >
      {isDone ? "Terminé" : "En cours"}
    </Badge>
    );
};

